import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { requestPasswordReset } from "service";
import { toast } from "sonner";

interface IFormData {
  username: string;
}

interface IForgotPasswordResponse {
  status: string | null;
}

export const useForgotPassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<IFormData>({
    username: "",
  });

  const isFormComplete = () => {
    return formData.username;
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    mutate();
  };

  const { mutate, isPending } = useMutation<IForgotPasswordResponse>({
    mutationFn: async () => {
      const response = await requestPasswordReset(formData.username);
      return response;
    },
    onSuccess: () => {
      toast.success("Password reset link sent to your username address");
      navigate("/auth");
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return {
    formData,
    isFormComplete,
    handleInputChange,
    handleSubmit,
    isPending,
  };
};
